export default __webpack_public_path__ + "static/media/jeswin-jose.61fd952d.jpg";